<template>
  <div class="appendix">
    <div style="height: calc(100% - 80px)" :key="pdfUrl">
      <PdfViewer :loaded="loaded" :readComplete="readComplete" :url="pdfUrl" />
    </div>
    <div style="width: 100%; text-align: center">
      <van-button type="primary" class="btn" @click="before" :disabled="isDisabled">
        我已认真阅读
      </van-button>
    </div>
  </div>
</template>

<script>
import { Button, Toast } from "vant";
import httpApi from "../../utils/httpApi";
import text from "./text";
import PdfViewer from "../../components/PdfViewer.vue";

export default {
  name: "appendix",
  components: {
    [Button.name]: Button,
    PdfViewer,
  },
  data() {
    return {
      isLoaded: false,
      isDisabled: true,
      content: text.stock,
      submitForm: {},
      pdfUrl: "https://forexmaster.oss-cn-beijing.aliyuncs.com/openAccount/Client_Agreement.pdf",
    };
  },
  methods: {
    // PDF加载完成
    loaded() {
      this.isLoaded = true;
      Toast.clear();
    },
    // PDF阅读完成
    readComplete() {
      if (this.submitForm.stock_agreement !== "是") {
        this.isDisabled = false;
      }
    },
    async before() {
      const res = await this.$api.postChooseStepOne({
        ...this.submitForm,
        stock_agreement: "是",
      });
      if (res) {
        this.$router.back();
      }
    },
  },
  async mounted() {
    this.$store.commit("setStepsShow", false);
    this.$store.commit("setTitleValue", "客户协议书");
    const result = await httpApi.getChooseStepOne();
    const { data } = result;
    this.submitForm = data;
    if (!this.isLoaded) {
      Toast.loading({
        message: "文件加载中...",
        duration: 0,
        overlay: true,
      });
    }
  },
};
</script>

<style lang="less">
.appendix {
  text-align: left;
  height: 100%;

  .content {
    padding: @space-2;
    background: @contentColor;
    font-size: @font-size-2;
  }
  .btn {
    width: 80%;
    margin: @space-0 auto;
    margin-bottom: 0;
  }
}
</style>
